/**
 * Контракт синхронизации между клиентом и сервером.
 *
 * Исходящий поток — журнал событий: POST /api/sync/push.
 * Входящий поток — справочники и график: GET /api/sync/pull?since=<курсор>.
 *
 * Курсор — значение поля rev, которое проставляет триггер из общей
 * последовательности global_rev. Он монотонный и не зависит от часов сервера,
 * поэтому «отдай всё, что изменилось после X» работает корректно даже при
 * переводе времени и при одновременной правке нескольких таблиц.
 *
 * Числа BigInt (rev, граммы) передаются строками: JSON теряет точность
 * на числах больше 2^53.
 */
/** Ресурсы, которые клиент забирает при входящей синхронизации. */
export const SYNC_RESOURCES = [
    'sites',
    'machines',
    'shiftTemplates',
    'productSizes',
    'materialTypes',
    'recipes',
    'siteNorms',
    'machineNorms',
    'appSettings',
    'users',
    'shifts',
    'shiftAssignments',
    'dayOffWishes',
    'absences',
    'notifications',
];
/** Сколько строк одного ресурса сервер отдаёт за один запрос. */
export const DEFAULT_PULL_LIMIT = 500;
export function emptyPullChanges() {
    return {
        sites: [],
        machines: [],
        shiftTemplates: [],
        productSizes: [],
        materialTypes: [],
        recipes: [],
        siteNorms: [],
        machineNorms: [],
        appSettings: [],
        users: [],
        shifts: [],
        shiftAssignments: [],
        dayOffWishes: [],
        absences: [],
        notifications: [],
    };
}
// ─────────────────────────── параметры отправки ───────────────────────────
/** Задержки повтора при обрыве сети: 2с, 4с, 8с… не больше 5 минут. */
export const BACKOFF_BASE_MS = 2_000;
export const BACKOFF_MAX_MS = 5 * 60 * 1000;
export function backoffDelayMs(attempt, baseMs = BACKOFF_BASE_MS, maxMs = BACKOFF_MAX_MS) {
    if (attempt <= 0)
        return 0;
    const delay = baseMs * 2 ** (attempt - 1);
    return Math.min(delay, maxMs);
}
//# sourceMappingURL=sync.js.map